export function buildStockByWarehouse(
  additionalInventory: { quantity: number; warehouseId: string }[],
): Record<string, number> {
  const result: Record<string, number> = {};
  for (const inv of additionalInventory) {
    result[inv.warehouseId] = inv.quantity;
  }
  return result;
}
